// extracted by mini-css-extract-plugin
export default {"warning_content":"style_m_warning_content__c8C14","warning_content_title":"style_m_warning_content_title__BobjW","warning_content_info":"style_m_warning_content_info__P9SKf"};